module.exports = __webpack_public_path__ + "Kanit-Bold.7c212d49763f9f235390.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/src/assets/fonts/Kanit-Bold.ttf
// module id = ../../../../../src/assets/fonts/Kanit-Bold.ttf
// module chunks = styles